<template>
  <v-container>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="teal"
          large
          dark
          fab
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          @click="$router.push({ name: 'Admin.Users' })"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <span>Users</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="indigo"
          large
          dark
          fab
          v-bind="attrs"
          v-on="on"
          @click="$router.push({ name: 'Admin.Settings' })"
        >
          <v-icon>mdi-domain</v-icon>
        </v-btn>
      </template>
      <span>Company Settings</span>
    </v-tooltip>
  </v-container>
</template>
<script>
  export default {
    name: 'VAdminDashboard',
  }
</script>
